import React, { useState, useRef } from "react";
import Foodvendorcoupsdetails from "../Food/Foodvendorcoupsdetails";
import "./Analysis.css";
import { Link } from "react-router-dom";
import Cateringsaddcoups from "./Cateringsaddcoups";
import Topratedcaters from "./Topratedcaters";

const Promotionscaterings = () => {
    const [activeTab, setActiveTab] = useState("Coupons");
    const [formData1, setFormData1] = useState({
        "offer type": "",
        "Discount Percentage": "",
        "Start Date": "",
        "End Date": "",
        Description: "",
        goal: "",
        status: "Active", // Added status
    });
    const tabContent = {
        "Coupons": <Cateringsaddcoups />,
        "Vendor List": <Foodvendorcoupsdetails />,
        "Vendor Rating": <Topratedcaters />,
        // "Main Page": <MainData />,
    };

    return (
        <div className="container-fluid">
            <div className="row">
                <div className="col-lg-2"></div>
                <div className="col-lg-10" style={{ height: "80vh", overflowY: "auto", marginTop: "142px", scrollbarWidth: "none" }}>
                    <p
                        className="breadcrumb maamaas-home-bredcum or7"
                        style={{
                            position: "fixed",
                            top: "58px",
                            left: "1vw",
                            width: "100%",
                            backgroundColor: "#fff",
                            // zIndex: 1000,
                            padding: "10px 0",
                            fontSize: "18px",
                            fontWeight: "bold",
                            textAlign: "center",
                            margin: 0,
                        }}
                    >
                        <Link
                            to="/Homes"
                            style={{
                                color: "purple",
                                fontWeight: "bold",
                                textDecoration: "none",
                            }}
                        >
                            Home
                        </Link>

                        <span className="separator"> &gt; </span>
                        <span
                            style={{
                                color: "purple",
                                fontWeight: "bold",
                                textDecoration: "none",
                            }}
                        >
                            <Link

                                style={{
                                    color: "purple",
                                    fontWeight: "bold",
                                    textDecoration: "none",
                                }}
                            >
                                Promotions_Discounts
                            </Link>
                        </span>
                        <span className="separator"> &gt; </span>
                        <span
                            style={{
                                color: "purple",
                                fontWeight: "bold",
                                textDecoration: "none",
                            }}
                        >
                            Catering & Services
                        </span>
                    </p>
                    <div className="discount-container">
                        {/* Responsive, centered tab buttons */}
                        <div
                            style={{
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                position: "fixed",
                                top: "122px",
                                left: "55%",
                                transform: "translate(-45%, -50%)",
                                gap: "0px",
                                zIndex: 10,
                                width: "90vw",
                                maxWidth: "600px",
                                flexWrap: "wrap",
                                padding: "10px 0",
                            }}
                            className="rorr row b2"
                        >
                            {Object.keys(tabContent).map((label) => (
                                <div
                                    key={label}
                                    className="col-lg-3 col-md-6 col-sm-12 col-12"
                                    style={{
                                        display: "flex",
                                        justifyContent: "center",
                                        marginBottom: "10px",
                                        minWidth: "150px",
                                    }}
                                >
                                    <button
                                        onClick={() => setActiveTab(label)}
                                        style={{
                                            border: "none",
                                            borderRadius: "10px",
                                            minWidth: "140px",
                                            width: "100%",
                                            padding: "0 10px",
                                            height: "40px",
                                            backgroundColor: activeTab === label ? "#b15cd6" : "#d9d9d9",
                                            color: activeTab === label ? "#fff" : "#000",
                                            fontWeight: "bold",
                                            cursor: "pointer",
                                            transition: "background-color 0.3s ease",
                                            fontSize: "1rem",
                                        }}
                                    >
                                        {label}
                                    </button>
                                </div>
                            ))}
                        </div>
                        {/* Tab Content - Scrollable Part */}
                        <div
                            style={{
                                height: "95vh",
                                overflowY: "auto",
                                scrollbarWidth: "none",
                                borderRadius: "8px",
                                marginTop: "0px",
                            }}
                            className="b1"
                        >
                            {tabContent[activeTab]}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};



export default Promotionscaterings;
